import { CoreMenu } from "@core/types";

export const menu: CoreMenu[] = [
  // {
  //   id: "avatars",
  //   title: "Trips",
  //   translate: "Trips",
  //   type: "collapsible",
  //   icon: "users",
  //   children: [

  //           {
  //             id: "terms-and-conditions",
  //             title: "Pending Children",
  //             translate: "Pending Children",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips",
  //             translate: "Trips",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips Ride Status",
  //             translate: "Trips Ride Status",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Request meeting",
  //             translate: "Request meeting",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //   ],
  // },
  // {
  //   id: "members",
  //   title: "Members",
  //   translate: "Members",
  //   type: "collapsible",
  //   icon: "paperclip",
  //   children: [

  //           {
  //             id: "terms-and-conditions",
  //             title: "Pending Children",
  //             translate: "Pending Children",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips",
  //             translate: "Trips",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips Ride Status",
  //             translate: "Trips Ride Status",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Request meeting",
  //             translate: "Request meeting",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //   ],
  // },
  // {
  //   id: "orders",
  //   title: "Orders",
  //   translate: "Orders",
  //   type: "collapsible",
  //   icon: "bookmark",
  //   children: [

  //           {
  //             id: "terms-and-conditions",
  //             title: "Pending Children",
  //             translate: "Pending Children",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips",
  //             translate: "Trips",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips Ride Status",
  //             translate: "Trips Ride Status",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Request meeting",
  //             translate: "Request meeting",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //   ],
  // },
  // {
  //   id: "plans",
  //   title: "Plans",
  //   translate: "Plans",
  //   type: "collapsible",
  //   icon: "video",
  //   children: [

  //           {
  //             id: "terms-and-conditions",
  //             title: "Pending Children",
  //             translate: "Pending Children",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips",
  //             translate: "Trips",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips Ride Status",
  //             translate: "Trips Ride Status",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Request meeting",
  //             translate: "Request meeting",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //   ],
  // },
  // {
  //   id: "vouchers",
  //   title: "Vouchers",
  //   translate: "Vouchers",
  //   type: "collapsible",
  //   icon: "calendar",
  //   children: [

  //           {
  //             id: "terms-and-conditions",
  //             title: "Pending Children",
  //             translate: "Pending Children",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips",
  //             translate: "Trips",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips Ride Status",
  //             translate: "Trips Ride Status",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Request meeting",
  //             translate: "Request meeting",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //   ],
  // },
  // {
  //   id: "points",
  //   title: "Points",
  //   translate: "Points",
  //   type: "collapsible",
  //   icon: "book",
  //   children: [

  //           {
  //             id: "terms-and-conditions",
  //             title: "Pending Children",
  //             translate: "Pending Children",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips",
  //             translate: "Trips",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips Ride Status",
  //             translate: "Trips Ride Status",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Request meeting",
  //             translate: "Request meeting",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //   ],
  // },
  // {
  //   id: "places",
  //   title: "Places",
  //   translate: "Places",
  //   type: "collapsible",
  //   icon: "check-square",
  //   children: [

  //           {
  //             id: "terms-and-conditions",
  //             title: "Pending Children",
  //             translate: "Pending Children",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips",
  //             translate: "Trips",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Trips Ride Status",
  //             translate: "Trips Ride Status",
  //             type: "collapsible",
  //             icon: "lock",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "terms-conditions",
  //               },
  //             ],
  //           },
  //           {
  //             id: "terms-and-conditions",
  //             title: "Request meeting",
  //             translate: "Request meeting",
  //             type: "collapsible",
  //             icon: "file-text",
  //             children: [
  //               {
  //                 id: "terms-show-details",
  //                 title: "List",
  //                 translate: "List",
  //                 type: "item",
  //                 icon: "circle",
  //                 url: "about",
  //               },
  //             ],
  //           },
  //   ],
  // },
  {
    id: "settings",
    title: "Home",
    translate: "MENU.DASHBOARD.HOME",
    type: "item",
    icon: "home",
    url: "home", // added this to define navigation path
  },
  {
    id: "chats",
    title: "Support Chat",
    translate: "MENU.DASHBOARD.supportChat",
    type: "item",
    icon: "help-circle",
    url: "chats",
  },
  {
    id: "chats",
    title: "Chat View",
    translate: "MENU.DASHBOARD.chatView",
    type: "item",
    icon: "message-square",
    url: "chat-view",
  },
  {
    id: "content",
    title: "Content",
    translate: "MENU.DASHBOARD.CONTENT",
    type: "collapsible",
    icon: "file-text",
    children: [
      {
        id: "contests",
        title: "Contests",
        translate: "MENU.DASHBOARD.contests",
        type: "item",
        icon: "circle",
        url: "contests",
      },
      {
        id: "stories",
        title: "Stories",
        translate: "MENU.DASHBOARD.stories",
        type: "item",
        icon: "circle",
        url: "stories",
      },
    ],
  },
  // {
  //   id: "settings",
  //   title: "Daily Users",
  //   translate: "MENU.DASHBOARD.dailyUser",
  //   type: "collapsible",
  //   icon: "users",
  //   children: [

  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "daily-users",
  //     },

  //   ],
  // },
  {
    id: "settings",
    title: "Users",
    translate: "MENU.DASHBOARD.users",
    type: "collapsible",
    icon: "shuffle",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "users",
      },
    ],
  },
  {
    id: "settings",
    title: "Books",
    translate: "MENU.DASHBOARD.books",
    type: "collapsible",
    icon: "book",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "book",
      },
      {
        id: "avatars-list",
        title: "Add New Book",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-book",
      },
      {
        id: "avatars-list",
        title: "Add New Store Book",
        translate: "MENU.DASHBOARD.addS",
        type: "item",
        icon: "circle",
        url: "add-book-store",
      },
      {
        id: "avatars-list",
        title: "Most View Books",
        translate: "MENU.DASHBOARD.mostViewBook",
        type: "item",
        icon: "circle",
        url: "most-view-books",
      },
    ],
  },
  {
    id: "settings",
    title: "Articles",
    translate: "MENU.DASHBOARD.articles",
    type: "collapsible",
    icon: "help-circle",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "articles",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.ADD_ARTICLE",
        type: "item",
        icon: "circle",
        url: "add-article",
      },
    ],
  },
  {
    id: "settings",
    title: "Main Categories",
    translate: "MENU.DASHBOARD.mainCategory",
    type: "collapsible",
    icon: "bookmark",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "main-categories",
      },
      // {
      //   id: "avatars-list",
      //   title: "Add New Book",
      //   translate: "MENU.DASHBOARD.add",
      //   type: "item",
      //   icon: "circle",
      //   url: "add-new-book-main",
      // },
    ],
  },
  {
    id: "settings",
    title: "Sub Categories",
    translate: "MENU.DASHBOARD.subCategory",
    type: "collapsible",
    icon: "video",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "sub-cat",
      },
    ],
  },
  {
    id: "settings",
    title: "Open Screens",
    translate: "MENU.DASHBOARD.openScreens",
    type: "collapsible",
    icon: "check-square",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "open-screen",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-open-screen",
      },
    ],
  },
  {
    id: "settings",
    title: " Fake Users",
    translate: "MENU.DASHBOARD.fakeUserss",
    type: "collapsible",
    icon: "help-circle",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "fake-user",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-fake-user",
      },
    ],
  },
  {
    id: "settings",
    title: "Reports",
    translate: "MENU.DASHBOARD.reports",
    type: "collapsible",
    icon: "file-text",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "reports",
      },
    ],
  },
  {
    id: "settings",
    title: "askBook",
    translate: "MENU.DASHBOARD.ASK_BOOKS",
    type: "collapsible",
    icon: "book-open",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "ask-books",
      },
    ],
  },
  {
    id: "settings",
    title: "Email Click",
    translate: "MENU.DASHBOARD.CLICK",
    type: "collapsible",
    icon: "file-text",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "email-click",
      },
    ],
  },
  {
    id: "settings",
    title: "Social Links",
    translate: "MENU.DASHBOARD.SOCIAL_LINKS",
    type: "collapsible",
    icon: "share-2",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "social-links",
      },

      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-social-links",
      },
    ],
  },
  {
    id: "monetization",
    title: "Monetization",
    translate: "MENU.DASHBOARD.MONETIZATION",
    type: "collapsible",
    icon: "dollar-sign",
    children: [
      {
        id: "monetization-terms",
        title: "Terms",
        translate: "MENU.DASHBOARD.MONETIZATION_TERMS",
        type: "item",
        icon: "circle",
        url: "monetization-terms",
      },
      {
        id: "monetization-requests",
        title: "Requests",
        translate: "MENU.DASHBOARD.MONETIZATION_REQUESTS",
        type: "item",
        icon: "circle",
        url: "monetization-requests",
      },
    ],
  },
  //   {
  //   id: "settings",
  //   title: "Email Click",
  //   translate: " لوحة تحكم الموبيلات",
  //   type: "collapsible",
  //   icon: "file-text",
  //   children: [

  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "mobile",
  //     },
  //          {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-fake-user",
  //     },

  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Ads",
  //   translate:  "MENU.DASHBOARD.ads",
  //   type: "collapsible" ,
  //   icon: "image",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "ads",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-ads",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Counselors",
  //   translate:  "MENU.DASHBOARD.counselors",
  //   type: "collapsible",
  //   icon: "package",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "Stores",
  //       type: "item",
  //       icon: "circle",
  //       url: "counselors",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-counselors",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Stores Offers",
  //   translate:  "MENU.DASHBOARD.stores_offers",
  //   type: "collapsible",
  //   icon: "dollar-sign",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "Vouchers",
  //       type: "item",
  //       icon: "circle",
  //       url: "StoresOffers-Vouchers",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "StoresOffers-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Cancelation Reason",
  //   translate:  "MENU.DASHBOARD.cancelation_reason",
  //   type: "collapsible",
  //   icon: "tablet",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "CancelationReasons",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "CancelationReasons-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Companies",
  //   translate:  "MENU.DASHBOARD.companies",
  //   type: "collapsible",
  //   icon: "hexagon",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Companies",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Companies-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Consulting",
  //   translate:  "MENU.DASHBOARD.consulting",
  //   type: "collapsible",
  //   icon: "credit-card",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Consulting",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Consulting-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Categories",
  //   translate:  "MENU.DASHBOARD.categories",
  //   type: "collapsible",
  //   icon: "percent",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Categories",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Categories-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Services",
  //   translate:  "MENU.DASHBOARD.services",
  //   type: "collapsible",
  //   icon: "map-pin",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Services",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Services-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Tags",
  //   translate:  "MENU.DASHBOARD.tags",
  //   type: "collapsible",
  //   icon: "video",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Tags",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Tags-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Articles",
  //   translate:  "MENU.DASHBOARD.articles",
  //   type: "collapsible",
  //   icon: "upload",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Articles",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Articles-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Offers",
  //   translate: "MENU.DASHBOARD.offers",
  //   type: "collapsible",
  //   icon: "settings",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Offers",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Offers-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Plant Cards",
  //   translate:  "MENU.DASHBOARD.plantcards",
  //   type: "collapsible",
  //   icon: "flag",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "planetCards",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "planetCards-add",
  //     },
  //   ],
  // },

  // {
  //   id: "settings",
  //   title: "Settings",
  //   translate: "MENU.DASHBOARD.Settings",
  //   type: "collapsible", // Allows the menu to be clickable and expandable
  //   icon: "help-circle",
  //   children: [
  //     {
  //       id: "show-details",
  //       title: "Show Details",
  //       translate: "MENU.DASHBOARD.ShowDetails",
  //       type: "item",
  //       icon: "circle",
  //       url: "settings",
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Terms & Conditions",
  //       translate: "MENU.DASHBOARD.TermsAndConditions",
  //       type: "collapsible", // Expandable item with children
  //       icon: "lock",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "terms-conditions",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "About",
  //       translate: "MENU.DASHBOARD.About",
  //       type: "collapsible", // Expandable item with children
  //       icon: "file-text",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "about",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Notifications",
  //       translate: "MENU.DASHBOARD.Notifications",
  //       type: "collapsible", // Expandable item with children
  //       icon: "shuffle",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "Notifications",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Currencies",
  //       translate: "MENU.DASHBOARD.Currencies",
  //       type: "collapsible", // Expandable item with children
  //       icon: "package",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "currencies",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "curriences-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Countries",
  //       translate: "MENU.DASHBOARD.Countries",
  //       type: "collapsible", // Expandable item with children
  //       icon: "gift",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "countries",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "countries-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Cities",
  //       translate: "MENU.DASHBOARD.Cities",
  //       type: "collapsible", // Expandable item with children
  //       icon: "grid",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "cities",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "cities-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.plans",
  //       translate: "MENU.DASHBOARD.plans",
  //       type: "collapsible", // Expandable item with children
  //       icon: "calendar",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "plans",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languagePlans-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Open Screens",
  //       translate: "MENU.DASHBOARD.OpenScreens",
  //       type: "collapsible", // Expandable item with children
  //       icon: "video",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "open-screen",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "openScreens-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.light",
  //       translate: "MENU.DASHBOARD.light",
  //       type: "collapsible", // Expandable item with children
  //       icon: "list",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "light",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageLight-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Ganatak community",
  //       translate: "MENU.DASHBOARD.GanatakCommunity",
  //       type: "collapsible", // Expandable item with children
  //       icon: "help-circle",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "ganatak",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "ganatakCommunity-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.root",
  //       translate: "MENU.DASHBOARD.root",
  //       type: "collapsible", // Expandable item with children
  //       icon: "paperclip",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "root",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageRoot-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.seed",
  //       translate: "MENU.DASHBOARD.seed",
  //       type: "collapsible", // Expandable item with children
  //       icon: "check-square",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "seed",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageSeed-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.soil",
  //       translate: "MENU.DASHBOARD.soil",
  //       type: "collapsible", // Expandable item with children
  //       icon: "file-text",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "soil",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageSoil-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.stem",
  //       translate: "MENU.DASHBOARD.stem",
  //       type: "collapsible", // Expandable item with children
  //       icon: "bookmark",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "stem",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageStem-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Paperform",
  //       translate: "MENU.DASHBOARD.Paperform",
  //       type: "collapsible", // Expandable item with children
  //       icon: "book",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "paperform",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "paperForm-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Sizes",
  //       translate: "MENU.DASHBOARD.Sizes",
  //       type: "collapsible", // Expandable item with children
  //       icon: "book-open",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "sizes",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "sizes-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.counselorspayment",
  //       translate: "MENU.DASHBOARD.counselorspayment",
  //       type: "collapsible", // Expandable item with children
  //       icon: "bar-chart-2",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "counselorPayment",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageConsulers-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Sliders",
  //       translate: "MENU.DASHBOARD.Sliders",
  //       type: "collapsible", // Expandable item with children
  //       icon: "sliders",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "sliders",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "sliders-add",
  //         },
  //       ],
  //     },

  //   ],
  // },
];
